import ApiService from "../api";

export default class SubCanalService extends ApiService {

    constructor() {
        super('/api/solicitacoes/config/subcanais')
    }

    listar() {
        return this.get("");
    }

    listarAtivos() {
        return this.get("/ativos");
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(id, dto) {
        return this.put(`/${id}`, dto);
    }

    excluir(id) {
        return this.delete(`/${id}`);
    }
}
